<template>
    <span class="enum-text">{{$tools.getLabelByValue(value / 1, allEnumListMap[dicCode])}}</span>
</template>

<script>
/**
 * @author 于新哲
 *
 * 用于显示枚举的文本组件
 */
import enumMixin from '../mixin/enum.js';

export default {
    name: 'XxEnumText',
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
    },
    mixins: [enumMixin]
};
</script>
